import { render, staticRenderFns } from "./EmployeeEdit.vue?vue&type=template&id=74c264e0&scoped=true&"
import script from "./EmployeeEdit.vue?vue&type=script&lang=js&"
export * from "./EmployeeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c264e0",
  null
  
)

export default component.exports